<template>
    <div class="container-fuild">
        <card v-if='livro'>
            <div class="header">
                <h4 class="title">Reservar Livro</h4>
                <strong>{{livro.titulo}}</strong>
                <div>{{livro.subtitulo}}</div>
            </div>
            <div class="content">
                <form @submit.prevent.stop='submit()'>
                  <div class='row'>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Membro</label>
                            <multiselect v-if='membros.length' @remove='update' @input='update' track-by='id' label='name' v-model="emprestimo.membro" :options="membros" :allow-empty="false"></multiselect>
                        </div>
                    </div>
                  </div>
                  <div class="text-center">
                    <button type="submit" class="btn btn-info btn-fill btn-wd">Salvar</button>
                  </div>
                </form>
            </div>
        </card>
    </div>
</template>
<script>
import OverlayService from '../services/overlay-service'
import ReservaService from '../services/reserva-service'
import Multiselect from 'vue-multiselect'
import DatePicker from 'vue2-datepicker'
import { mapState } from 'vuex' 

export default {
  components: {
    Multiselect,
    DatePicker
  },

  computed: {
    ...mapState(['obras','membros'])
  },

  watch: {
    $route (to, from) {
      this.id = this.$route.params.id
      this.livro = this.obras.find(o => o.id == this.id)
    }
  },

  data () {
    return {
      id: undefined,
      livro: undefined,
      emprestimo: {},
    }
  },

  mounted () {
    this.id = this.$route.params.id
    this.livro = this.obras.find(o => o.id == this.id)
  },

  methods: {

    toggleMembro () {
      this.emprestimo.nao_membro = !this.emprestimo.nao_membro
    },

    update () {
      this.$forceUpdate()
    },

    submit () {
      const toSave = JSON.parse(JSON.stringify(this.emprestimo))

      if (!toSave.membro) {
        this.$alertify.error('Selecione o Membro')
        return
      }

      toSave.obra_id = this.id
      toSave.emprestado_para = toSave.membro.id
      delete toSave.membro
      toSave.membro = toSave.emprestado_para
      delete toSave.emprestado_para

      OverlayService.trigger('show', true)

      ReservaService.nova(toSave)
        .then(emprestimo => emprestimo.data)
        .then(emprestimo => {
          this.$alertify.success('Reserva Criada Com Sucesso!')

          window.location.href = '/#/reservas'
        }).catch(er => {
          let message = 'Erro ao criar reserva'

          if (er.response.data.message) {
            message = this.$t(er.response.data.message)
          }
          this.$alertify.error(message)
          OverlayService.trigger('show', false)
        })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
